import styled, { css } from 'styled-components';

export const VideoWrapper = styled.div`
  ${({ theme }) => css`
    height: 260px;
    width: 465px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
      max-width: 465px;
    }
  `};
`;
